import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Row, Col, CardBody, Card, Container, Form, FormFeedback, Label, Input, Alert, Button } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { vendorRegister } from "../../store/actions";
import logoSm from "../../assets/images/logo-sm.png";

const VendorRegister = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [selectedFile, setSelectedFile] = useState(null);

    const { user, registrationError, loading } = useSelector(state => ({
        user: state.Account.user,
        registrationError: state.Account.registrationError,
        loading: state.Account.loading,
    }));

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
        }
    };

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: '',
            email: '',
            password: '',
            mobile: '',
            whatsapp_number: '',
            store_name: '',
            business_name: '',
            id_proof_number: '',
            tl_number: '',
            vat_number: '',
            corporate_address: '',
            bank_name: '',
            bank_branch: '',
            account_name: '',
            account_number: '',
            iban: '',
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Please Enter Your Name"),
            email: Yup.string().email().required("Please Enter Your Email"),
            password: Yup.string().required("Please Enter Your Password"),
            mobile: Yup.string().required("Please Enter Your Mobile Number"),
            whatsapp_number: Yup.string().required("Please Enter Your WhatsApp Number"),
            store_name: Yup.string().required("Please Enter Store Name"),
            business_name: Yup.string().required("Please Enter Business Name"),
            id_proof_number: Yup.string().required("Please Enter ID Proof Number"),
            tl_number: Yup.string().required("Please Enter TL Number"),
            vat_number: Yup.string().required("Please Enter VAT Number"),
            corporate_address: Yup.string().required("Please Enter Corporate Address"),
            bank_name: Yup.string().required("Please Enter Bank Name"),
            bank_branch: Yup.string().required("Please Enter Bank Branch"),
            account_name: Yup.string().required("Please Enter Account Name"),
            account_number: Yup.string().required("Please Enter Account Number"),
            iban: Yup.string().required("Please Enter IBAN"),
        }),
        onSubmit: (values) => {
            const formData = new FormData();
            Object.keys(values).forEach(key => {
                formData.append(key, values[key]);
            });
            if (selectedFile) {
                formData.append('id_proof_file', selectedFile);
            }
            dispatch(vendorRegister(formData, navigate));
        }
    });

    document.title = "Vendor Register | Bawaba";

    return (
        <React.Fragment>
            <div className="account-pages my-5 pt-sm-5">
                <Container>
                    <Row className="justify-content-center">
                        <Col md={10} lg={8} xl={8}>
                            <Card className="overflow-hidden">
                                <div className="bg-primary">
                                    <div className="text-primary text-center p-4">
                                        <h5 className="text-white font-size-20">Vendor Registration</h5>
                                        <p className="text-white-50">Join our marketplace as a vendor.</p>
                                    </div>
                                </div>
                                <CardBody className="p-4">
                                    <Form className="mt-4" onSubmit={(e) => {
                                        e.preventDefault();
                                        validation.handleSubmit();
                                        return false;
                                    }}>
                                        {registrationError && <Alert color="danger">{registrationError}</Alert>}
                                        {user && <Alert color="success">Registration successful! Redirecting to login...</Alert>}

                                        <h4 className="card-title mb-4">Personal Information</h4>
                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Full Name</Label>
                                                    <Input name="name" type="text" placeholder="Enter full name" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name} invalid={validation.touched.name && validation.errors.name ? true : false} />
                                                    {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Email</Label>
                                                    <Input name="email" type="email" placeholder="Enter email" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.email} invalid={validation.touched.email && validation.errors.email ? true : false} />
                                                    {validation.touched.email && validation.errors.email ? <FormFeedback type="invalid">{validation.errors.email}</FormFeedback> : null}
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Password</Label>
                                                    <Input name="password" type="password" placeholder="Enter password" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.password} invalid={validation.touched.password && validation.errors.password ? true : false} />
                                                    {validation.touched.password && validation.errors.password ? <FormFeedback type="invalid">{validation.errors.password}</FormFeedback> : null}
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Mobile Number</Label>
                                                    <Input name="mobile" type="text" placeholder="Enter mobile number" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.mobile} invalid={validation.touched.mobile && validation.errors.mobile ? true : false} />
                                                    {validation.touched.mobile && validation.errors.mobile ? <FormFeedback type="invalid">{validation.errors.mobile}</FormFeedback> : null}
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">WhatsApp Number</Label>
                                                    <Input name="whatsapp_number" type="text" placeholder="Enter whatsapp number" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.whatsapp_number} invalid={validation.touched.whatsapp_number && validation.errors.whatsapp_number ? true : false} />
                                                    {validation.touched.whatsapp_number && validation.errors.whatsapp_number ? <FormFeedback type="invalid">{validation.errors.whatsapp_number}</FormFeedback> : null}
                                                </div>
                                            </Col>
                                        </Row>

                                        <h4 className="card-title mt-4 mb-4">Business Information</h4>
                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Store Name</Label>
                                                    <Input name="store_name" type="text" placeholder="Enter store name" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.store_name} invalid={validation.touched.store_name && validation.errors.store_name ? true : false} />
                                                    {validation.touched.store_name && validation.errors.store_name ? <FormFeedback type="invalid">{validation.errors.store_name}</FormFeedback> : null}
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Business Name</Label>
                                                    <Input name="business_name" type="text" placeholder="Enter business name" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.business_name} invalid={validation.touched.business_name && validation.errors.business_name ? true : false} />
                                                    {validation.touched.business_name && validation.errors.business_name ? <FormFeedback type="invalid">{validation.errors.business_name}</FormFeedback> : null}
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">ID Proof Number</Label>
                                                    <Input name="id_proof_number" type="text" placeholder="Enter ID proof number" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.id_proof_number} invalid={validation.touched.id_proof_number && validation.errors.id_proof_number ? true : false} />
                                                    {validation.touched.id_proof_number && validation.errors.id_proof_number ? <FormFeedback type="invalid">{validation.errors.id_proof_number}</FormFeedback> : null}
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">ID Proof File</Label>
                                                    <Input name="id_proof_file" type="file" onChange={handleFileChange} />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">TL Number</Label>
                                                    <Input name="tl_number" type="text" placeholder="Enter TL number" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.tl_number} invalid={validation.touched.tl_number && validation.errors.tl_number ? true : false} />
                                                    {validation.touched.tl_number && validation.errors.tl_number ? <FormFeedback type="invalid">{validation.errors.tl_number}</FormFeedback> : null}
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">VAT Number</Label>
                                                    <Input name="vat_number" type="text" placeholder="Enter VAT number" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.vat_number} invalid={validation.touched.vat_number && validation.errors.vat_number ? true : false} />
                                                    {validation.touched.vat_number && validation.errors.vat_number ? <FormFeedback type="invalid">{validation.errors.vat_number}</FormFeedback> : null}
                                                </div>
                                            </Col>
                                        </Row>
                                        <div className="mb-3">
                                            <Label className="form-label">Corporate Address</Label>
                                            <Input name="corporate_address" type="textarea" placeholder="Enter corporate address" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.corporate_address} invalid={validation.touched.corporate_address && validation.errors.corporate_address ? true : false} />
                                            {validation.touched.corporate_address && validation.errors.corporate_address ? <FormFeedback type="invalid">{validation.errors.corporate_address}</FormFeedback> : null}
                                        </div>

                                        <h4 className="card-title mt-4 mb-4">Bank Details</h4>
                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Bank Name</Label>
                                                    <Input name="bank_name" type="text" placeholder="Enter bank name" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.bank_name} invalid={validation.touched.bank_name && validation.errors.bank_name ? true : false} />
                                                    {validation.touched.bank_name && validation.errors.bank_name ? <FormFeedback type="invalid">{validation.errors.bank_name}</FormFeedback> : null}
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Bank Branch</Label>
                                                    <Input name="bank_branch" type="text" placeholder="Enter bank branch" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.bank_branch} invalid={validation.touched.bank_branch && validation.errors.bank_branch ? true : false} />
                                                    {validation.touched.bank_branch && validation.errors.bank_branch ? <FormFeedback type="invalid">{validation.errors.bank_branch}</FormFeedback> : null}
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Account Name</Label>
                                                    <Input name="account_name" type="text" placeholder="Enter account name" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.account_name} invalid={validation.touched.account_name && validation.errors.account_name ? true : false} />
                                                    {validation.touched.account_name && validation.errors.account_name ? <FormFeedback type="invalid">{validation.errors.account_name}</FormFeedback> : null}
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Account Number</Label>
                                                    <Input name="account_number" type="text" placeholder="Enter account number" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.account_number} invalid={validation.touched.account_number && validation.errors.account_number ? true : false} />
                                                    {validation.touched.account_number && validation.errors.account_number ? <FormFeedback type="invalid">{validation.errors.account_number}</FormFeedback> : null}
                                                </div>
                                            </Col>
                                        </Row>
                                        <div className="mb-3">
                                            <Label className="form-label">IBAN</Label>
                                            <Input name="iban" type="text" placeholder="Enter IBAN" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.iban} invalid={validation.touched.iban && validation.errors.iban ? true : false} />
                                            {validation.touched.iban && validation.errors.iban ? <FormFeedback type="invalid">{validation.errors.iban}</FormFeedback> : null}
                                        </div>

                                        <div className="mt-4 d-grid">
                                            <Button color="primary" className="waves-effect waves-light" type="submit" disabled={loading}>
                                                {loading ? "Registering..." : "Register as Vendor"}
                                            </Button>
                                        </div>

                                        <div className="mt-4 text-center">
                                            <p className="mb-0">Already have an account ? <Link to="/login" className="fw-medium text-primary">Login</Link></p>
                                        </div>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default VendorRegister;
